<ca-element-loader [loading]="loading" [translucent]="true">
  @if (categories) {
    <mat-chip-listbox class="relationships" multiple>
      @for (category of categories; track category) {
        @switch (category.name) {
          @case ("Christmas") {
            <ca-animated-category
              [category]="category"
              [selected]="_selected | arrayIncludes: category.id"
              (toggleEvent)="toggle(category.id)"
            ></ca-animated-category>
          }
          @case ("Easter") {
            <ca-animated-category
              [category]="category"
              [selected]="_selected | arrayIncludes: category.id"
              (toggleEvent)="toggle(category.id)"
            ></ca-animated-category>
          }
          @case ("Elf") {
            <ca-animated-category
              [category]="category"
              [selected]="_selected | arrayIncludes: category.id"
              (toggleEvent)="toggle(category.id)"
            ></ca-animated-category>
          }
          @case ("Olympics") {
            <ca-animated-category
              [category]="category"
              [selected]="_selected | arrayIncludes: category.id"
              (toggleEvent)="toggle(category.id)"
            ></ca-animated-category>
          }
          @case ("Halloween") {
            <ca-animated-category
              [category]="category"
              [selected]="_selected | arrayIncludes: category.id"
              (toggleEvent)="toggle(category.id)"
            ></ca-animated-category>
          }
          @case ("Valentine's Day") {
            <ca-animated-category
              [category]="category"
              [selected]="_selected | arrayIncludes: category.id"
              (toggleEvent)="toggle(category.id)"
            ></ca-animated-category>
          }
          @case ("St. Patrick's Day") {
            <ca-animated-category
              [category]="category"
              [selected]="_selected | arrayIncludes: category.id"
              (toggleEvent)="toggle(category.id)"
            ></ca-animated-category>
          }
          @default {
            <mat-basic-chip-option
              [value]="category.id"
              [selected]="_selected | arrayIncludes: category.id"
              [class.selected]="_selected | arrayIncludes: category.id"
              (click)="toggle(category.id)"
              color="secondary"
            >
              <ca-badge class="transparent" [name]="category.icon"></ca-badge>
              {{ category.name }}
            </mat-basic-chip-option>
          }
        }
      }
    </mat-chip-listbox>
  }
</ca-element-loader>
